import {Dbg} from '../util.js';
import {Sysex} from '../sysex.js';
import {NumParam, AsciiParam} from '../parsing_formatting/parameters.js';
import {Parser} from '../parsing_formatting/parser.js';
import {FormattingUtils} from '../parsing_formatting/formattingutils.js';
import {Checksum} from '../parsing_formatting/checksum.js';
import {Constants} from "../constants.js";
const _ = require('lodash/core');


// ************ DX7 sysex data format

const parameterChangeFormat =
  [0xf0, 0x43, 0x10, undefined, undefined, undefined, 0xf7];

const voiceDataHeader =
  [0xf0, 0x43, 0x00, 0x00, 0x01, 0x1b];

const bankDataHeader =
  [0xf0, 0x43, 0x00, 0x09, 0x20, 0x00];


const parameterChangeSize = 7;
const packedVoiceDataSize = 128;
const standardVoiceDataSize = (6+155+2);
const bankDataSize = 6 + packedVoiceDataSize*32 + 2;


// Packed single-voice layout (used in 32-voice bulk dumps)
// NOTE: Offsets are from the start of the parameter data block (not from start of Sysex)
let packedVoiceParams = [
  // Common parameters
  new NumParam(102, 'Pitch EG Rate 1', 0, 99),
  new NumParam(103, 'Pitch EG Rate 2', 0, 99),
  new NumParam(104, 'Pitch EG Rate 3', 0, 99),
  new NumParam(105, 'Pitch EG Rate 4', 0, 99),
  new NumParam(106, 'Pitch EG Level 1', 0, 99),
  new NumParam(107, 'Pitch EG Level 2', 0, 99),
  new NumParam(108, 'Pitch EG Level 3', 0, 99),
  new NumParam(109, 'Pitch EG Level 4', 0, 99),
  new NumParam(110, 'Algorithm', 0, 31, 5, 0),
  new NumParam(111, 'Oscillator sync', 0, 1, 1, 3),
  new NumParam(111, 'Feedback', 0, 7, 3, 0),
  new NumParam(112, 'LFO Speed', 0, 99),
  new NumParam(113, 'LFO Delay', 0, 99),
  new NumParam(114, 'LFO Pitch mod depth', 0, 99),
  new NumParam(115, 'LFO Amp mod depth', 0, 99),
  new NumParam(116, 'Pitch mod sensitivity', 0, 7, 3, 4),
  new NumParam(116, 'LFO Waveform', 0, 5, 3, 1),
  new NumParam(116, 'LFO Sync', 0, 1, 1, 0),
  new NumParam(117, 'Transpose', 0, 48),
  new AsciiParam(118, 'Voice name', 10)
];
for (let op = 0; op < 6; op++) {
  // Operator 1-6 parameters
  let offset = (5-op)*17; // OPs are stored in reverse order
  let prefix = 'OP' + (op+1).toString() + '_';
  packedVoiceParams.push(new NumParam(offset+0,  prefix+'EG Rate 1', 0, 99));
  packedVoiceParams.push(new NumParam(offset+1,  prefix+'EG Rate 2', 0, 99));
  packedVoiceParams.push(new NumParam(offset+2,  prefix+'EG Rate 3', 0, 99));
  packedVoiceParams.push(new NumParam(offset+3,  prefix+'EG Rate 4', 0, 99));
  packedVoiceParams.push(new NumParam(offset+4,  prefix+'EG Level 1', 0, 99));
  packedVoiceParams.push(new NumParam(offset+5,  prefix+'EG Level 2', 0, 99));
  packedVoiceParams.push(new NumParam(offset+6,  prefix+'EG Level 3', 0, 99));
  packedVoiceParams.push(new NumParam(offset+7,  prefix+'EG Level 4', 0, 99));
  packedVoiceParams.push(new NumParam(offset+8,  prefix+'Keyboard level scale break point', 0, 99));
  packedVoiceParams.push(new NumParam(offset+9,  prefix+'Keyboard level scale left depth', 0, 99));
  packedVoiceParams.push(new NumParam(offset+10, prefix+'Keyboard level scale right depth', 0, 99));
  packedVoiceParams.push(new NumParam(offset+11, prefix+'Keyboard level scale left curve', 0, 3, 2, 2));
  packedVoiceParams.push(new NumParam(offset+11, prefix+'Keyboard level scale right curve', 0, 3, 2, 0));
  packedVoiceParams.push(new NumParam(offset+12, prefix+'Osc detune', 0, 14, 4, 3));
  packedVoiceParams.push(new NumParam(offset+12, prefix+'Keyboard rate scaling', 0, 7, 3, 0));
  packedVoiceParams.push(new NumParam(offset+13, prefix+'Keyboard velocity sensitivity', 0, 7, 3, 2));
  packedVoiceParams.push(new NumParam(offset+13, prefix+'Amp mod sensitivity', 0, 3, 2, 0));
  packedVoiceParams.push(new NumParam(offset+14, prefix+'Output level', 0, 99));
  packedVoiceParams.push(new NumParam(offset+15, prefix+'Osc frequency coarse', 0, 31, 5, 1));
  packedVoiceParams.push(new NumParam(offset+15, prefix+'Osc mode', 0, 1, 1, 0));
  packedVoiceParams.push(new NumParam(offset+16, prefix+'Osc frequency fine', 0, 99));
}

// Standard single-voice layout
// NOTE: Offsets are from the start of the parameter data block (not from start of Sysex)
let standardVoiceParams = [
  // Common parameters
  new NumParam(126, 'Pitch EG Rate 1', 0, 99),
  new NumParam(127, 'Pitch EG Rate 2', 0, 99),
  new NumParam(128, 'Pitch EG Rate 3', 0, 99),
  new NumParam(129, 'Pitch EG Rate 4', 0, 99),
  new NumParam(130, 'Pitch EG Level 1', 0, 99),
  new NumParam(131, 'Pitch EG Level 2', 0, 99),
  new NumParam(132, 'Pitch EG Level 3', 0, 99),
  new NumParam(133, 'Pitch EG Level 4', 0, 99),
  new NumParam(134, 'Algorithm', 0, 31),
  new NumParam(135, 'Feedback', 0, 7),
  new NumParam(136, 'Oscillator sync', 0, 1),
  new NumParam(137, 'LFO Speed', 0, 99),
  new NumParam(138, 'LFO Delay', 0, 99),
  new NumParam(139, 'LFO Pitch mod depth', 0, 99),
  new NumParam(140, 'LFO Amp mod depth', 0, 99),
  new NumParam(141, 'LFO Sync', 0, 1),
  new NumParam(142, 'LFO Waveform', 0, 5),
  new NumParam(143, 'Pitch mod sensitivity', 0, 7),
  new NumParam(144, 'Transpose', 0, 48),
  new AsciiParam(145, 'Voice name', 10)
];
for (let op = 0; op < 6; op++) {
  // Operator 1-6 parameters
  let offset = (5-op)*21; // OPs are stored in reverse order
  let prefix = 'OP' + (op+1).toString() + '_';
  standardVoiceParams.push(new NumParam(offset+0,  prefix+'EG Rate 1', 0, 99));
  standardVoiceParams.push(new NumParam(offset+1,  prefix+'EG Rate 2', 0, 99));
  standardVoiceParams.push(new NumParam(offset+2,  prefix+'EG Rate 3', 0, 99));
  standardVoiceParams.push(new NumParam(offset+3,  prefix+'EG Rate 4', 0, 99));
  standardVoiceParams.push(new NumParam(offset+4,  prefix+'EG Level 1', 0, 99));
  standardVoiceParams.push(new NumParam(offset+5,  prefix+'EG Level 2', 0, 99));
  standardVoiceParams.push(new NumParam(offset+6,  prefix+'EG Level 3', 0, 99));
  standardVoiceParams.push(new NumParam(offset+7,  prefix+'EG Level 4', 0, 99));
  standardVoiceParams.push(new NumParam(offset+8,  prefix+'Keyboard level scale break point', 0, 99));
  standardVoiceParams.push(new NumParam(offset+9,  prefix+'Keyboard level scale left depth', 0, 99));
  standardVoiceParams.push(new NumParam(offset+10, prefix+'Keyboard level scale right depth', 0, 99));
  standardVoiceParams.push(new NumParam(offset+11, prefix+'Keyboard level scale left curve', 0, 3));
  standardVoiceParams.push(new NumParam(offset+12, prefix+'Keyboard level scale right curve', 0, 3));
  standardVoiceParams.push(new NumParam(offset+13, prefix+'Keyboard rate scaling', 0, 7));
  standardVoiceParams.push(new NumParam(offset+14, prefix+'Amp mod sensitivity', 0, 3));
  standardVoiceParams.push(new NumParam(offset+15, prefix+'Keyboard velocity sensitivity', 0, 7));
  standardVoiceParams.push(new NumParam(offset+16, prefix+'Output level', 0, 99));
  standardVoiceParams.push(new NumParam(offset+17, prefix+'Osc mode', 0, 1));
  standardVoiceParams.push(new NumParam(offset+18, prefix+'Osc frequency coarse', 0, 31));
  standardVoiceParams.push(new NumParam(offset+19, prefix+'Osc frequency fine', 0, 99));
  standardVoiceParams.push(new NumParam(offset+20, prefix+'Osc detune', 0, 14));
}

// Index by name

let packedVoiceParamsMap = new Map();
for (let p of packedVoiceParams) packedVoiceParamsMap.set(p.name, p);

let standardVoiceParamsMap = new Map();
for (let p of standardVoiceParams) standardVoiceParamsMap.set(p.name, p);



/** Yamaha DX7 Parameter Change sysex */
export class DX7ParameterChange extends Sysex
{
  /** Construct a DX7ParameterChange sysex from raw sysex data.
   * @param {Uint8Array} rawData Raw sysex data
   */
  constructor(rawData = undefined) {
    super(rawData);
    this.device = 'DX7';
    this.type = 'Parameter change';
    this.isKnownType = true;
    let group = DX7ParameterChange.getGroup(rawData);
    if (group === 0) {
      this.type += " (voice)"
    }
    else if (group === 2) {
      this.type += " (function)"
    }
  }

  static test(rawData) {
    if (!super.test(rawData)) return false;
    if (!Parser.matchesPattern(rawData, parameterChangeFormat)) return false;
    if (rawData.byteLength !== parameterChangeSize) return false;
    // Group (bits 3-6 of byte 3) should be either 0 (voice) or 2 (function)
    let group = DX7ParameterChange.getGroup(rawData);
    if (!((group === 0) || (group === 2))) return false;
    return true;
  }


  ///// Helpers

  static getGroup(rawData) { return rawData[3]>>2; }
}



/** Yamaha DX7 single-voice data dump */
export class DX7Voice extends Sysex
{
  /** Construct a DX7Voice sysex from raw sysex data.
   * @param {Uint8Array} rawData Raw sysex data (either packed or standard format)
   */
  constructor(rawData = undefined) {
    super(); // can't init from rawData, since packed voice is technically not a valid sysex
    this.device = 'DX7';
    this.type = 'Single voice';
    this.isKnownType = true;
    this.canParse = true;

    if (rawData == undefined)
    {
      this.rawData = new Uint8Array(standardVoiceDataSize);
      this.paramData = new Uint8Array(
        this.rawData.buffer, this.rawData.byteOffset+6, 155);
      this.rawData.set(voiceDataHeader);
      this.rawData[this.rawData.byteLength-1] = Constants.END_OF_SYSEX;
    }
    else if (rawData.length == standardVoiceDataSize)
    {
      this.rawData = rawData;
      this.paramData = new Uint8Array(
        this.rawData.buffer, this.rawData.byteOffset+6, 155);
    }
    else if (rawData.length == packedVoiceDataSize)
    {
      // Packed format: Convert to standard format via parsed data
      let parsedData = {};
      Parser.parseAll(packedVoiceParams, rawData, parsedData, false);
      this.initFromParameterValues(parsedData);
    }

    this.parseManufacturer(); // since we didn't pass data to super()
    this.name = this.getParameterValue('Voice name');
  }

  /** See Sysex.test() */
  static test(rawData) {
    if (!super.test(rawData)) return false;
    if (!Parser.matchesPattern(rawData, voiceDataHeader)) return false;
    if (rawData.byteLength != standardVoiceDataSize) return false;
    return true;
  }

  getParameterNames() {
    return _.map(standardVoiceParams, p => p.name);
  }

  getParameterValue(parameterName) {
    if (!(standardVoiceParamsMap.has(parameterName))) {
      console.log('parameter ' + parameterName + ' not found');
      return undefined;
    }
    let parameter = standardVoiceParamsMap.get(parameterName);
    let result = Parser.parse(parameter, this.paramData, true);
    return result.value;
  }

  validate() {
    // Validate parameter data
    let warnings = Parser.validateAll(
      standardVoiceParams, this.paramData, true);

    // Validate checksum
    let expectedChecksum = Checksum.twoComplement7Bit(this.paramData);
    let actualChecksum = this.rawData[161];
    if (expectedChecksum != actualChecksum) {
      warnings.push('Invalid checksum. Was ' + actualChecksum + " expected " + expectedChecksum);
    }
    return warnings;
  }

  toObject() {
    var parsedData = {};
    var warnings = Parser.parseAll(standardVoiceParams,
      this.paramData, parsedData, true);
    return parsedData;
  }

  static fromObject(object) {
    let s = new DX7Voice();
    Parser.formatAll(standardVoiceParams, s.paramData, object, true);
    s.name = s.getParameterValue('Voice name');
    s.updateChecksum();
    return s;
  }


  ///// Helpers

  /** Formats and returns the 128-byte packed raw parameter data
   *  for this sysex.
   * @returns {Uint8Array}
   */
  getPackedRawData() {
    // convert to packed format via parsed data
    let parameters = toObject();
    let rawData = new Uint8Array(packedVoiceDataSize);
    Parser.formatAll(packedVoiceParams, rawData, parameters, false);

    return rawData;
  }

  initFromParameterValues(parameterValues) {
    this.rawData = new Uint8Array(standardVoiceDataSize);
    this.rawData.set(voiceDataHeader);
    this.rawData[this.rawData.byteLength-1] = Constants.END_OF_SYSEX;
    this.paramData = new Uint8Array(
      this.rawData.buffer, this.rawData.byteOffset+6, 155);
    let warnings = Parser.formatAll(standardVoiceParams,
      this.paramData, parameterValues, true);
    this.updateChecksum();
  }

  updateChecksum() {
    // NOTE: checksum is for the 155 parameter data bytes only
    this.rawData[161] = Checksum.twoComplement7Bit(this.paramData);
  }
}



/** Yamaha DX7 32-voice bank dump */
export class DX7Bank extends Sysex
{
    constructor(rawData = undefined) {
      super(rawData);
      this.device = 'DX7';
      this.type = '32-voice bank';
      this.isKnownType = true;
      this.canParse = true;

      if (rawData == undefined)
      {
        this.rawData = new Uint8Array(bankDataSize);
        this.rawData.set(bankDataHeader);
        this.rawData[this.rawData.byteLength-1] = Constants.END_OF_SYSEX;
      }
      else if (rawData.length != bankDataSize)
      {
        throw new Error('Data was ' + rawData.length +
          ' bytes, expected ' + bankDataSize);
      }
    }

    /** See Sysex.test() */
    static test(rawData) {
      if (!super.test(rawData)) return false;
      if (!Parser.matchesPattern(rawData, bankDataHeader)) return false;
      if (rawData.byteLength != bankDataSize) return false;
      return true;
    }

    getParameterNames() {
      return [];
    }

    getParameterValue(parameterName) {
      return undefined;
    }

    validate () {
      let warnings = [];

      // Validate sub-items
      for (let i = 0; i < this.getSubItemCount(); i++) {
        let subItem = this.getSubItem(i);
        let results = subItem.validate();
        warnings.concat(results);
      }

      // Validate checksum
      let checksumData = new Uint8Array(this.rawData.buffer,
        this.rawData.byteOffset + voiceDataHeader.length, 4096);
      let expectedChecksum = Checksum.twoComplement7Bit(checksumData);
      let actualChecksum = this.rawData[4102];
      if (expectedChecksum != actualChecksum) {
        warnings.push('Invalid checksum');
      }

      return warnings;
    }

    toObject() {
      var result = { voices: [] };
      for (let n = 0; n < 32; n++) {
        let voiceSysex = this.getSubItem(n);
        result.voices.push(voiceSysex.toObject());
      }
      return result;
    }

    // TODO: static fromObject(object)

    getSubItemNames() {
      // TODO: OPTIMIZE
      let subItemNames = [];
      for (var i = 0; i < 32; i++) {
        let subItem = this.getSubItem(i);
        subItemNames.push(subItem.getParameterValue('Voice name'));
      }
      return subItemNames;
    }

    getSubItemCount() {
      return 32;
    }

    getSubItem(number) {
      if (number < 0 || number >= 32) {
        throw new Error('SubItem number is out of range.');
      }
      let offset = 6 + 128*number;
      var data = new Uint8Array(this.rawData.buffer,
        this.rawData.byteOffset + offset, 128);
      let sysex = new DX7Voice(data);
      return sysex;
    }

    setSubItem(number, sysex) {
      if (number < 0 || number >= 32) {
        throw new Error('SubItem number is out of range.');
      }
      if (!sysex instanceof DX7Voice) {
        throw new Error('SysEx must be DX7 single voice');
      }
      var data = sysex.getPackedRawData();
      let offset = 6 + 128*number;
      this.rawData.set(data, offset);
    }

    updateChecksum() {
      // NOTE: checksum is for the 4096 parameter data bytes only
      let checksumData = new Uint8Array(this.rawData.buffer,
        this.rawData.byteOffset + voiceDataHeader.length, 4096);
      this.rawData[4102] = Checksum.twoComplement7Bit(checksumData);
    }
}



// WEBPACK FOOTER //
// ./src/yamaha/dx7.js